import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-canvasAlt" data-id="element-73" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-74" data-mp="3ggk7gsifd7yh">
        <p className="text-[0.68rem] leading-snug text-ink-subtle" data-id="element-75" data-mp="32ovukn0cqfgg">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1.5 text-[0.66rem] leading-snug text-ink-subtle" data-id="element-76" data-mp="36ppivhhphw9v">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, práctica supervisada, manuales de fabricantes, normativa
          eléctrica, construcción, incendio, evacuación, accesibilidad,
          licencias, certificaciones, permisos ni el criterio de un profesional
          habilitado. Toda instalación, configuración y práctica debe realizarse
          únicamente sobre sistemas propios o expresamente autorizados y
          siguiendo las normas de seguridad aplicables.
        </p>
        <p className="mt-1.5 text-[0.68rem] text-ink-muted" data-id="element-77" data-mp="2ew700loelk6h">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-cyan transition-colors duration-150 ease-soft hover:text-accent" data-id="element-78" data-mp="3la27uq37evt4">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-[0.68rem] text-ink-muted" data-id="element-79" data-mp="3v5dhitzr9cu0">
          <a href="#terminos" className="transition-colors duration-150 ease-soft hover:text-accent" data-id="element-80" data-mp="80xkia4293k5">
            Términos y Condiciones
          </a>
          <span className="text-ink-subtle" data-id="element-81" data-mp="hsa8gqmqn9kw">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-soft hover:text-accent" data-id="element-82" data-mp="ct765dy57hgm">
            Política de Privacidad
          </a>
          <span className="text-ink-subtle" data-id="element-83" data-mp="ms6gd0yk3l5q">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-soft hover:text-accent" data-id="element-84" data-mp="mthlp57nh0yy">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}